<template>
  <v-card class="next-page-card rounded-lg h-100 white" outlined elevation="5">
    <div
      class="d-flex flex-column align-center justify-center gap-3 h-100 pa-4 white"
    >
      <v-icon size="80" color="primary">$arrowForward</v-icon>
      <span class="card-title">{{ $t("nextPageCard.title") }}</span>
      <span class="card-desc">{{
        $t("nextPageCard.page", [currentPage + 1])
      }}</span>
      <div class="w-100">
        <v-btn x-large block color="primary" @click="goToNextPage">
          {{ $t("nextPageCard.button") }}
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "NextPageCard",
  props: {
    currentPage: {
      type: Number,
      required: true
    }
  },
  methods: {
    goToNextPage() {
      this.$emit("nextPage", this.currentPage + 1);
    }
  }
};
</script>

<style scoped lang="scss">
.next-page-card {
  border-color: $gray-border-color !important;
  .card-title {
    font-size: 24px;
    font-weight: 900;
  }
  .card-desc {
    font-size: 18px;
  }
  .gap-3 {
    gap: 8px;
  }
}
</style>
